export default "__VITE_ASSET__BKgvBJ2a__"